// import { Injectable } from '@angular/core';
// import * as FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';

// const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
// const EXCEL_EXTENSION = '.xlsx';
// @Injectable({
//   providedIn: 'root'
// })
// export class ExcelService {
//   constructor() { }
//   public exportAsExcelFile(json: any[], excelFileName: string): void {
//     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
//     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     this.saveAsExcelFile(excelBuffer, excelFileName);
//   }
//   private saveAsExcelFile(buffer: any, fileName: string): void {
//      const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
//      FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
//   }
//   public exportAsExcelFileExceptHeader(json: any[], excelFileName: string): void {
//     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json,{skipHeader: true});
//     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] ,  };
//     const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array' });
//     this.saveAsExcelFile(excelBuffer, excelFileName);
  
//   }
//   }
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, FormControlName } from '@angular/forms';
import { NgbModal, NgbDateStruct, NgbCalendar, NgbDate,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { environment } from '../../environments/environment';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root'
})
export class ExcelService {
  attachment1_form: FormGroup;
  attachments_form: string;
  image_or_video: string;
  modalcloseimage: any;
  ByDefault: boolean;
  image_name: string;
  isImageSaved: boolean;
  imageinput: boolean;
  constructor(public modalService: NgbModal) { }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const transformedHeaders = Object.keys(json[0] || {}).map(
      (key) => key.charAt(0).toUpperCase() + key.slice(1)
    );
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const headerRange = XLSX.utils.decode_range(worksheet['!ref'] || ''); // Get range
  if (headerRange.s.r === 0) { // If the first row is the header row
    transformedHeaders.forEach((header, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex }); // Header cell address
      if (!worksheet[cellAddress]) {
        worksheet[cellAddress] = { v: header, t: 's' }; // Add header cell
      } else {
        worksheet[cellAddress].v = header; // Update header value
      }
    });
  }
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
  }
  public exportAsExcelFileExceptHeader(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json,{skipHeader: true});
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] ,  };
    const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  
  }
  // attachment details work by harish june27
  attachments(item,attchPopup){
      this.attachment1_form=new FormGroup({
        "attachment1": new FormControl(item.resolution_image),
        "attachment2": new FormControl(item.resolution_image2),
        "attachment3": new FormControl(item.resolution_image3)
      })
    this.modalService.open(attchPopup, {
      size: 'lg',
      windowClass: "center-modalsm",        //popup size change harish
      backdrop: 'static',                                        
      keyboard: false
    });
    
  }
  //  attachment showning work by harish june27
  downloadPdf2(pdfName: string, pdfUrl: string,modal) {
    this.attachments_form =pdfName
    var image_type;
    var filetypes;
    (pdfUrl!=null && pdfUrl!="")? filetypes = pdfUrl.split('.').pop(): filetypes = "";
    if(filetypes == "" || filetypes == "null" || filetypes == null){
      image_type = "";
    }
    else if (filetypes =='png' || filetypes == 'jpeg' || filetypes == 'jpg'|| filetypes == 'JPG' ||filetypes == 'JPEG') {
      image_type = "image";
    }
    else if (filetypes == "mp4"){
      image_type = "video";
    }
    else if (filetypes == "pdf"){
      image_type = "pdf";
    }
    else if (filetypes == "doc" || filetypes == "docx"){
      image_type = "word";
    }
    if(image_type == "pdf") {
      var pdf = environment.image_static_ip + pdfUrl;
      FileSaver.saveAs(pdf);
    }
    else{
      this.image_or_video = pdfUrl;
      this.modalcloseimage = this.modalService.open(modal, {
      size: 'lg',
      windowClass: "attachment-modalsm",                           //design popup changed
      backdrop: 'static',                                          //popup outside click by Sowndarya
      keyboard: false
      });
      this.ByDefault = false;
      this.image_name = 'Image';
      this.isImageSaved = false;
      this.imageinput = false;
    }
    }
    // download attachment work by harish june27
    download(pdfName: string,pdfUrl: string) {                   //function for download sowmiya   
      var file_name = pdfName;    
      FileSaver.saveAs(environment.image_static_ip +pdfUrl);
    }
  }